import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../styles/colors';

const useStyles = makeStyles({
  presentation: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  modalPresentation: {
    outline: 'none',
  },
  modalCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    background: colors.white,
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    minWidth: '518px',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 24px',
    alignItems: 'center',
    height: '67px',
    width: '100%',
    borderBottom: `1px solid ${colors.lightGray}`,
  },
  headerIcon: {
    cursor: 'pointer',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '68px',
    padding: '0 24px',
  },
});

export default useStyles;
